import { Injectable } from '@angular/core';

import * as _ from 'lodash';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';

import { Logger } from '../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McLisOrderService {

  constructor(
    private sdk: MycureSDK,
  ) { }

  async loadPendingOrders(patient: string) {
    const query = {
      patient, $pending: true,
      $populate: {
        tests: {
          service: 'lis-tests', key: 'tests'
        }
      }
    };

    let res: any = await this.sdk.lis.orders().find(query);
    res.items = res.items.map((order: any) => {
      return {
        ..._.omit(order, ['$populated']),
        _tests: order.$populated.tests || [],
      }
    });

    return res;
  }

  updateOrderSpecimen(id: string, specimen: any) {
    const values = { specimen };
    return this.sdk.lis.orders().update(id, values);
  }

  async loadOrders(facility: string, status: string, filter: any = undefined) {
    let query: any = {
      facility, $sort: { 'createdAt': -1 },
      $populate: {
        tests: {
          service: 'lis-tests', key: 'tests'
        }
      }
    };



    // filter by status
    if (status == 'completed') {
      query = {
        ...query,
        completedAt: { $exists: true },
        verifiedAt: { $exists: false },
        finalizedAt: { $exists: false },
        sentOutAt: { $exists: false },
      };
    } else if (status == 'finalized') {
      query = {
        ...query,
        completedAt: { $exists: true },
        finalizedAt: { $exists: true },
        verifiedAt: { $exists: true },
        sentOutAt: { $exists: false },
      };
    } else if (status == 'verified') {
      query = {
        ...query,
        completedAt: { $exists: true },
        verifiedAt: { $exists: true },
        finalizedAt: { $exists: false },
        sentOutAt: { $exists: false },
      };
    } else if (status == 'sendout') {
      query = {
        ...query,
        sentOutAt: { $exists: true },
      };
    } else if (status == 'pending') {
      query[`$pending`] = true;
    }

    // if has filter
    if (filter && filter.start && filter.end) {
      let start = new Date(filter.start); start.setHours(0, 0, 0, 0);
      let end = new Date(filter.end); end.setHours(23, 59, 59, 0);
      query = {
        ...query,
        createdAt: { $lte: end, $gte: start },
        $dateFields: ['createdAt.$gte', 'createdAt.$lte']
      };
    }

    let res: any = await this.sdk.lis.orders().find(query);
    res.items = res.items.map((order: any) => {
      const tests = order.$populated.tests || [];
      const names = tests.map((item: any) => item.name) || [];

      return {
        ..._.omit(order, ['$populated']),
        _testsNames: names.join(', ')
      }
    });

    return res;
  }

  async loadOrder(id: string) {
    const query: any = {
      id,
      $populate: {
        tests: {
          service: 'lis-tests', key: 'tests',
          $populate: {
            measures: {
              service: 'lis-measures',
              key: 'id', method: 'find',
              idField: 'test'
            }
          }
        }
      }
    };

    let res: any = await this.sdk.lis.orders().findOne(query);
    if (!res && !res.order) throw new Error('no records');

    res = {
      ..._.omit(res, ['$populated']),
      _tests: res.$populated.tests,
    };

    // if has _test, move measures
    if (res._tests) {
      res._tests = res._tests.map((item: any) => {
        return {
          ..._.omit(item, ['$populated']),
          _measures: item.$populated.measures,
        }
      });
    }

    return res;
  }

  async createResult(data: any, updatedStatus: string = undefined, token: string = undefined) {
    if (!data.id) throw new Error('no order found');

    // remove existing results, if has results already.
    if (data.results && data.results.length != 0) {
      const existingResultId = data.results.map((item: any) => item.id);
      const update1: any = { $pull: { results: { id: { $in: existingResultId } } } };
      await this.sdk.lis.orders().update(data.id, update1);
    }

    let update2: any = _.pick(_.pickBy(data, _.identity), ['method', 'specimen', 'remarks', 'technician', 'pathologist']);

    // add results, if has modified ones
    if (data._results && data._results.length != 0) {
      update2 = { ...update2, $addToSet: { results: { $each: data._results } } };
    }

    // update order status
    if (updatedStatus) {
      if (updatedStatus == 'finalize') update2['finalize'] = true;
      if (updatedStatus == 'sendout') update2['sendOut'] = true;
      if (updatedStatus == 'complete') update2['complete'] = true;
      if (updatedStatus == 'verify') update2['verify'] = true;
    }

    // if has token return an update with custom token
    if (token) {
      return this.sdk.lis.orders().update(data.id, update2, { accessToken: token });
    }

    return this.sdk.lis.orders().update(data.id, update2);
  }

  removeOrder(id: string) {
    return this.sdk.lis.orders().remove(id);
  }
}
